import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { Items } from 'src/app/core/models/common/items.model';
import { OnDemandPickupResponse } from 'src/app/core/models/operations/operations-on-demand-pickup.model';
import { OperationsPickup } from 'src/app/core/models/operations/operations-pickup.model';
import { ScheduledPickupResponse } from 'src/app/core/models/operations/operations-scheduled-pickup.model';

export enum ColumnIds {
  ROUTE = 'route',
  STOP_TYPE = 'stopType',
  IDO_SUGGESTION = 'IDOsuggestion',
  STATUS = 'status',
  PACKAGE_TYPE = 'packageType',
  SHIPPER_PRN = 'shipperPrn',
  STREET_ADDRESS = 'streetAddress',
  CITY = 'city',
  POSTAL = 'postal',
  READY_TIME = 'readyTime',
  COMMIT_TIME = 'commitTime',
  COMPLETE_TIME = 'completeTime',
  GROUP = 'group',
}


export const ColumnText = {
  ROUTE: $localize`Route`.toUpperCase(),
  STOP_TYPE: $localize`Stop Type`.toUpperCase(),
  IDO_SUGGESTION: $localize`IDO Suggestion`.toUpperCase(),
  STATUS: $localize`Status`.toUpperCase(),
  PACKAGE_TYPE: $localize`Package Type`.toUpperCase(),
  SHIPPER_PRN: $localize`Shipper/PRN`.toUpperCase(),
  STREET_ADDRESS: $localize`Address`.toUpperCase(),
  CITY: $localize`City`.toUpperCase(),
  POSTAL: $localize`Postal Code`.toUpperCase(),
  READY_TIME: $localize`Ready Time`.toUpperCase(),
  COMMIT_TIME: $localize`Commit Time`.toUpperCase(),
  COMPLETE_TIME: $localize`Complete Time`.toUpperCase(),
  GROUP: $localize`Group`.toUpperCase(),
  SORT_BY_UNASSIGNED: $localize`Sort by unassigned`,
  SORT_BY_ASSIGNED: $localize`Sort by assigned`,
};

export const SUITE = $localize`Suite`;
export const FLOOR = $localize`Floor`;

export const STOP_TYPES: Items[] = [
  { id: 'OnDemand', src: IMAGE_SRC.PHONE, selected: true },
  { id: 'Scheduled', src: IMAGE_SRC.PICKUP, selected: true },
];

export const ROUTE_STATUSES: Items[] = [
  { id: 'Assigned', selected: true },
  { id: 'Unassigned', selected: true },
];

export const STATUSES: Items[] = [
  { id: 'Active', selected: true },
  { id: 'Pending', selected: true },
  { id: 'Accepted', selected: true },
  { id: 'Rejected', selected: true },
  { id: 'Completed', selected: true },
  { id: 'Interrupted', selected: true },
  { id: 'Inactive', selected: true },
  { id: 'Cancelled', selected: true },
];

export const PACKAGE_TYPES: Items[] = [
  { id: 'Package', src: IMAGE_SRC.ALT_CHECKBOX, selected: true },
  { id: 'Letter', src: IMAGE_SRC.CANCEL, selected: true },
  { id: 'Pallet', src: IMAGE_SRC.CANCEL, selected: true },
];

export const EXCEL_FILE_NAME = 'pickup-operations-data';

export const MOCK_DATA: OperationsPickup[] = [
  {
    id: 1233,
    route: '',
    customerName: 'abc',
    province: 'test',
    stopType: STOP_TYPES[0].id,
    IDOsuggestion: '213',
    status: 'Active',
    packageType: 'PKG',
    shipperPrn: 'A32132132',
    streetAddress: '123 Random Street',
    addressCorrected: false,
    city: 'Scranton',
    postal: '12345',
    readyTime: '00:00',
    commitTime: '00:00',
    completeTime: '00:00',
    isRouteAssigned: false,
    countryCode: 'CA',
    idoEnabled: true,
  },
  {
    id: 123,
    route: '456',
    stopType: STOP_TYPES[1].id,
    customerName: 'abc2',
    province: 'test2',
    IDOsuggestion: '212',
    status: 'Inactive',
    packageType: 'Letter',
    shipperPrn: 'A321332132',
    streetAddress: '456 Random Street',
    addressCorrected: true,
    city: 'New York',
    postal: '22335',
    readyTime: '10:00',
    commitTime: '20:00',
    completeTime: '30:00',
    isRouteAssigned: true,
    countryCode: 'CA',
    idoEnabled: true,
  },
];

export const MOCK_SCHEDULED_PICKUP_DATA: ScheduledPickupResponse = {
  response: {
    schedulePickup: {
      ondemandPickUp: false,
      daysAssigned: {
        sunday: false,
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: false,
      },
      pickupPoint: 'Garage',
      route: 'AD2',
      startDate: '02/02/2021',
      endDate: '12/31/2099',
      readyTime: '15:00',
      commitTime: '17:00',
      closingTime: '17:00',
      restartDate: '12/31/2099',
      interruptDate: '12/12/2012',
      customerInfo: {
        shipperNo: '063X69',
        customerName: 'TUNDRA USER',
        contactName: 'Manager',
        contactNumber: '2345678901',
        streetAddress: '13',
        streetName: 'WREN DR',
        cityTown: 'STRATFORD',
        postalCode: 'C1B2C2',
        latitude: '+46.229935',
        longitude: '-63.094944',
        province: 'PE',
      },
    },
  },
};
export const MOCK_ONDEMAND_PICKUP_DATA: OnDemandPickupResponse = {
  response: {
    onDemandPickup: {
      requestShipperNo: '123ABC43',
      orderType: 'ONDEMAND',
      cstcSiteName: 'INET-FOR',
      orderDate: new Date('July 25 2023'),
      serviceCenter: '3436',
      cstcOperator: 'VJD1SJP',
      serviceDate: new Date('July 26 2023'),
      preferredCustomer: 'false',
      cstcSitePhone: '560045109',
      serviceType: 'STANDARD',
      packageType: 'PACKAGE',
      shipPUCharge: 0,
      shipperNumber: '589YW2',
      packageWeight: '5',
      vatPortion: '',
      pickupNumber: '1234567',
      overWeight: 'false',
      driverInstructions: '',
      readyTime: '9:00',
      commitTime: '5:00',
      closingTime: '12:00',
    },
    currentPickupAddress: {
      customerName: 'Susan Colling Marks',
      contactName: 'Susan Collin Marks',
      contact: '1234567890',
      streetAddress: '45',
      prefix: '',
      streetName: 'ANNE FRANKSTRAAT',
      suffix: '',
      streetType: '',
      suite: '',
      floor: '',
      cityTown: 'Amsterdam',
      province: 'Amsterdam',
      postalCode: '1018 DM',
      latitude: '',
      longitude: '',
    },
    originalAddress: {
      customerName: 'Susan Colling Marks',
      contactName: 'Susan Collin Marks',
      contact: '1234567890',
      streetAddress: '45 ANNE FRANKSTRAAT',
      prefix: '',
      streetName: '',
      suffix: '',
      streetType: '',
      suite: '',
      pickupLocation: '',
      floor: '',
      cityTown: 'Amsterdam',
      province: 'Amsterdam',
      postalCode: '1018 DM',
      numberofPkgs: 4,
      slic: '3436',
    },
    parsedAAAAddress: {
      customerName: 'Susan Colling Marks',
      contactName: 'Susan Collin Marks',
      contact: '1234567890',
      streetAddress: '45',
      prefix: '',
      streetName: 'ANNE FRANKSTRAAT',
      suffix: '',
      streetType: '',
      suite: '',
      pickupLocation: '',
      floor: '',
      cityTown: 'Amsterdam',
      province: '',
      postalCode: '1018DM',
      numberofPkgs: 4,
      slic: '3436',
    },
    sscDescription: '',
    driverReply: '',
    additionalInformation: '',
  },
};
